function normalizeStreamPayload(raw) {
  if (raw == null) return null;
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch (_) {
      return null;
    }
  }
  return raw;
}

function bindStreamMessageHandlers() {
  const streamElements = document.querySelectorAll('turbo-cable-stream-source');

  streamElements.forEach((element) => {
    if (element.dataset.vmpStreamActionsBound === '1') return;
    element.dataset.vmpStreamActionsBound = '1';

    element.addEventListener('message', function (event) {
      const data = normalizeStreamPayload(event.data);

      if (data && data.action === 'chrome_data_ready') {
        handleChromeDataReady(data);
      } else if (data && data.action === 'reprocess_complete') {
        handleReprocessComplete(data);
      } else if (data && data.action === 'reprocess_error') {
        handleReprocessError(data);
      }
    });
  });
}

function clearDecodeCompletionPolling() {
  if (window.decodeCompletionPollInterval != null) {
    clearInterval(window.decodeCompletionPollInterval);
    window.decodeCompletionPollInterval = null;
  }
}

function isSingleDecodeLoadingPath() {
  return /^\/decode\/[^/]+$/.test(window.location.pathname);
}

const DECODE_POLL_MAX_ATTEMPTS = 120;

async function pollDecodeHtmlForCompletion(state) {
  if (!document.getElementById('loading-gif')) {
    clearDecodeCompletionPolling();
    return;
  }
  state.attempts += 1;
  if (state.attempts > DECODE_POLL_MAX_ATTEMPTS) {
    clearDecodeCompletionPolling();
    return;
  }
  const path = window.location.pathname;
  try {
    const response = await fetch(path, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    });
    const html = await response.text();
    if (html.includes('single-vin-result') || html.includes('VIN Not Found')) {
      clearDecodeCompletionPolling();
      window.location.reload();
    }
  } catch (_) { }
}

function startDecodeCompletionPollingIfNeeded() {
  clearDecodeCompletionPolling();
  if (!isSingleDecodeLoadingPath()) return;
  if (!document.getElementById('loading-gif')) return;
  const state = { attempts: 0 };
  setTimeout(() => pollDecodeHtmlForCompletion(state), 1500);
  window.decodeCompletionPollInterval = setInterval(() => pollDecodeHtmlForCompletion(state), 2500);
}

function clearCompninePolling() {
  if (window.compninePollInterval != null) {
    clearInterval(window.compninePollInterval);
    window.compninePollInterval = null;
  }
}

async function pollCompnineResults(target, state) {
  state.attempts += 1;
  if (state.attempts > 10) {
    clearCompninePolling();
    return;
  }
  try {
    const url = `${window.location.pathname}/compnine_results?search_id=${target.dataset.compninePending}`;
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    });
    if (response.status === 200) {
      clearCompninePolling();
      target.innerHTML = await response.text();
    } else if (response.status !== 204) {
      clearCompninePolling();
    }
  } catch (_) { }
}

function startCompninePollingIfNeeded() {
  clearCompninePolling();
  if (!isSingleDecodeLoadingPath()) return;
  const target = document.querySelector('[data-compnine-pending]');
  if (!target) return;
  const state = { attempts: 0 };
  window.compninePollInterval = setInterval(() => pollCompnineResults(target, state), 3000);
}

document.addEventListener('turbo:load', function () {
  bindStreamMessageHandlers();
  startDecodeCompletionPollingIfNeeded();
  startCompninePollingIfNeeded();
});

function handleChromeDataReady(data) {
  const currentPath = window.location.pathname;
  const isSearchPage =
    currentPath.includes('/decode') ||
    currentPath.includes('/vin_compare') ||
    currentPath.includes('/vin_decode');

  if (isSearchPage) {
    clearDecodeCompletionPolling();
    const loadingCard = document.getElementById('loading-gif');
    if (loadingCard) {
      window.location.reload();
    } else {
      const searchContainer = document.querySelector(`#${data.search_type}-vin-search-${data.search_id}`);
      if (searchContainer) {
        window.location.reload();
      }
    }
  }
}

function handleReprocessComplete(data) {
  if (window.location.pathname.includes(data.vin_number.toLowerCase())) {
    window.location.reload();
  }
}

function handleReprocessError(data) {
  if (window.location.pathname.includes(data.vin_number.toLowerCase())) {
    alert('Unable to load detailed VIN information. Please try refreshing the page.');
  }
}
